import { FrameName } from "../config";
import AbstractSalvageableTileEntity from "./AbstractSalvageableTileEntity";

class ShallowSeaShipwreckSalvageableTileEntity extends AbstractSalvageableTileEntity {
	public static readonly frameName = FrameName.SHALLOW_SEA_SHIPWRECK;
}

export default ShallowSeaShipwreckSalvageableTileEntity;
